<div class="form-check" [class.form-switch]="isSwitch">
  <input [attr.data-testid]="data_testid" [checked]="checked" [attr.data-test]="label" class="form-check-input" type="checkbox" [id]="id" (change)="onClick($event)">
  <label class="form-check-label" [for]="id" [innerHTML]="label"></label>
</div>